import './Controller.scss'
import React, { useState, useEffect, createContext, useContext, useRef } from "react"
import { screens } from "components/sections/constants"
import { events } from "components/Scene/three/constants"
import { useDetector } from './hooks/useDetector'
import { controllerGlobalContext } from './context'
import { useLocation, useNavigate } from 'react-router-dom';

export const ControllerContext = createContext({} as any)

const sProps = {
    slideId: 'slide-id',
    scrollNextTo: 'scroll-next-to',
    scrollPrevTo: 'scroll-prev-to',
    innerSlides: 'inner-slides',
    parentId: 'parent-id'
}
const state = { changing: false } 

const Controller = ({ children }) => {
    const [ isLoaded, setIsLoaded ] = useState(false)
    const [ active, setActive ] = useState(screens.NONE)
    const [ innerActive, setInnerActive ] = useState(screens.NONE) // inner works only on scroll
    const [ prevActive, setPrevActive ] = useState(screens.NONE)
    const [ changing, setChanging ] = useState(state.changing)
    const [ to, setTo ] = useDetector(document, (h) => { if (!state.changing) { return h }; return () => {} })
    useEffect(() => { state.changing = changing }, [ changing ])
    const location = useLocation()
    const navigate = useNavigate()

    const slides = {}

    const value = {
        isLoaded, setIsLoaded,
        active, setActive,
        innerActive, setInnerActive,
        prevActive, setPrevActive,
        dispatchActive,
        dispatchInnerActive,
        slides
    }

    function dispatchActive( id ) {
        if (changing) { return }
        setPrevActive(active)
        setActive(id)
        trySetInnerActive(id)
        document.dispatchEvent(new CustomEvent(events.STATECHANGE, { detail: { id } }))
        setChanging(true) // написал здесь, чтобы небыло задержки ответа от сцены, из-за чего случаются проклики // типо костыль короче, но зато в проде все гуд
        controllerGlobalContext.active = id
        const to = id === 'hero' ? '/' : '/'+id
        navigate(to)
    }
    controllerGlobalContext.dispatchActive = dispatchActive
    function trySetInnerActive(id) { // для событий при клике мышкой
        const innerSlides = Object.keys(slides[id][sProps.innerSlides])
        if ( innerSlides.length > 1 ) {
            setInnerActive(innerSlides[0])
        }
    }
    function dispatchInnerActive( id, innerId ) {
        if (changing) { return }
        if (innerActive === innerId) { return }
        document.dispatchEvent(new CustomEvent(events.STATECHANGE, { detail: { id: innerId } }))
        if ( id !== active ) { 
            setPrevActive(active)
            setActive(id)
        }
        setInnerActive(innerId)
        setChanging(true) // написал здесь, чтобы небыло задержки ответа от сцены, из-за чего случаются проклики // типо костыль короче, но зато в проде все гуд
    }


    useEffect(() => {
        document.addEventListener(events.SETCHANGING, listener)
        // console.log(slides)
        return () => document.removeEventListener(events.SETCHANGING, listener)
    }, [])
    function listener(e) {
        const boolean = e.detail.changing
        if (typeof boolean !== 'boolean') { return }
        setChanging(boolean)
    }

    // todo: Доделать чертов скролл
    // 1. Иногда случается проклик через сцену
    // 2. Иногда(очень редко) выпадает ошибка которая все ломает в строке 175
    // В остальном работает стабильно, хоть что-то радует
    // !!!! ПОХОЖЕ БАГ ВОЗНИКАЕТ ИЗ_ЗА ПЕРЕХОДА ЧЕРЕЗ КЛИК. ЛИБО ЭТО ДРУГОЙ БАГ)) необходимо выставлять иннерслайд также и через клик
    useEffect(() => {
        // console.log('.................')
        // console.log('changing', changing)
        // console.log('state.changing', state.changing)
        // console.log('to', to)

        if (!isLoaded) { return }
        if (to === 0) { return }
        if (changing) { return }
        if (state.changing) { return }
        state.changing = true

        // console.log('')
        // console.log('................................')
        
        const [ nextSlide, nextInnerSlide ] = getSlide(active)


  
        // console.log('--> next id ', nextSlide)
        // console.log('--> nextInnerActive id ', nextInnerSlide)

        if (nextInnerSlide !== null) { dispatchInnerActive(nextSlide, nextInnerSlide)
        } else if (nextSlide !== null) { dispatchActive(nextSlide) }
        else {
            state.changing = false
            return
        }

        if (typeof setTo === 'function') { setTo(0) }

        // console.log('................................')
        // console.log('')
    }, [ to ])

    function getSlide(active) {
        const slide = {
            active: slides[active],
            innerActive: null,
            next: null,
        }
        const slideID = {
            next: null,
            nextInnerActive: null
        }

        if ( !getNextID(slide.active) ) {
            return [ slideID.next, slideID.nextInnerActive ]
        }

        // Если на актуальном слайде уже есть внутренние слайды, то следуем по ним
        if ( Object.keys(slide.active[sProps.innerSlides]).length > 1 ) {
            // тогда следующий слайд равен текущему
            slideID.next = active
            slide.next = slides[slideID.next]

            // тогда можем быть уверены, что переключаемся по внутренним и можем их посчитать
            // посчитаем текущий
            const innerSlides = slide.active[sProps.innerSlides]
            const innerKeys = Object.keys(innerSlides)
            slide.innerActive = innerSlides[innerActive]
            
            // и тогда следующий внутренний зависит от значения текущего внутреннего 
            slideID.nextInnerActive = getNextID(slide.innerActive)

            // однако неизвестно, возможно следующего внутреннего не существует и мы выходим за границы внутренних
            // поэтому необходимо проверить
            const isRealInner = innerKeys.includes(slideID.nextInnerActive)
            // если существует то все окей
            if (isRealInner) { return [ slideID.next, slideID.nextInnerActive ] }

            // если не существует, значит необходимо вернуть внешние слайды
            // значит пересчитать последующие, как будто мы движемся не по внутренним а по внешним
            slideID.next = getNextID(slide.active)
            slide.next = slides[slideID.next]
            slideID.nextInnerActive = null

            // также возможно, что следующий внешний тоже имеет внутренние
            // Поэтому необходимо просчитать его внутренние и заранее положить в стейт
            if ( Object.keys(slide.next[sProps.innerSlides]).length > 1 ) {
                const innerNextSlides = slide.next[sProps.innerSlides]
                const innerNextKeys = Object.keys(innerNextSlides)
    
                if (to === 1) {
                    // значит мы пришли слева (вперед)
                    slideID.nextInnerActive = innerNextKeys[0]
                }
    
                if (to === -1) {
                    // значит мы пришли справа (назад)
                    slideID.nextInnerActive = innerNextKeys[innerNextKeys.length - 1]
                }
            } 

            return [ slideID.next, slideID.nextInnerActive ]
        }
        // 


        // На актуальном слайде уже точно нет внутренних
        // Тогда нам нужно проверять, есть ли внутренние слайды, на последующих слайдах
        // Если на последующем нет, то мы просто движемся по внешним слайдам

        // Мы уверены, что следующий слайд, уже точно внешний
        // Поэтому
        slideID.next = getNextID(slide.active)
        slide.next = slides[slideID.next]

        // Однако, если на нем будут внутренние, значит нам нужно выставить корректный внутренний слайд

        // Проверяем следующий на внутренние слайды
        // todo: здесь отлетает ошибка, очень редко, но отлетает
        if ( Object.keys(slide.next[sProps.innerSlides]).length > 1 ) {
            // Значит там есть внутренние слайды
            // Нам необходимо определить с какой стороны мы пришли чтобы начать с корректного внутреннего слайда
            // и ( просто его положить в стейт, при этом возвращая null в поле с nextInnerSlide )

            // Получим внутренние
            const innerNextSlides = slide.next[sProps.innerSlides]
            const innerNextKeys = Object.keys(innerNextSlides)

            if (to === 1) {
                // значит мы пришли слева (вперед)
                slideID.nextInnerActive = innerNextKeys[0]
            }

            if (to === -1) {
                // значит мы пришли справа (назад)
                slideID.nextInnerActive = innerNextKeys[innerNextKeys.length - 1]
            }
        }

        return [ slideID.next, slideID.nextInnerActive ]
        
        function getNextID(slide) {
            if (to === 1) {
                return slide[sProps.scrollNextTo]
            }
            return slide[sProps.scrollPrevTo]
        }
    }


    return (
        <ControllerContext.Provider value={value}>
            <div className={`controller ${ !isLoaded ? '-not-loaded' : '-loaded' }`}>
                { children }
            </div>
        </ControllerContext.Provider>
    )
}

const ControllerSlides = ({ children }) => {
    const { active, prevActive, slides } = useContext(ControllerContext)
    return (
        <div className="controller-slides">
            {
                React.Children.map(children, (child) => {
                    if (!child.props.hasOwnProperty(sProps.slideId)) { console.error('[Controller]: slide-id prop is required'); return null; }
                    
                    const id = child.props[sProps.slideId]
                    const next = child.props.hasOwnProperty(sProps.scrollNextTo) ? child.props[sProps.scrollNextTo] : null
                    const prev = child.props.hasOwnProperty(sProps.scrollPrevTo) ? child.props[sProps.scrollPrevTo] : null
                    const innerSlides = child.props.hasOwnProperty(sProps.innerSlides) ? child.props[sProps.innerSlides] : null
                    
                    if (React.isValidElement(child)) {

                        slides[id] = { [sProps.scrollNextTo]: next, [sProps.scrollPrevTo]: prev, [sProps.innerSlides]: {} }
                        if (innerSlides) {
                            const length = Object.keys(innerSlides).length
                            Object.values(innerSlides).forEach((_:any, i) => {
                                const next = i + 1 < length ? innerSlides[i + 1].id : slides[id][sProps.scrollNextTo]
                                const prev = i - 1 >= 0 ? innerSlides[i - 1].id : slides[id][sProps.scrollPrevTo]
                                slides[id][sProps.innerSlides][_.id] = { [sProps.scrollNextTo]: next, [sProps.scrollPrevTo]: prev }
                            })
                        }

                        return (
                            <div className={`slide ${active === id ? '-active' : ''}${prevActive === id ? '-prev-active' : ''}`}>
                                {React.cloneElement(child as React.ReactElement<any>, {
                                    isActive: (active === id) as Boolean,
                                    [sProps.innerSlides]: innerSlides
                                })}
                            </div>
                        )
                    }
                    return null
                })
            }
        </div>
    )
}

// todo: можно сделать, чтобы кроме хардкода количества слайдов и айди он также собирал по дочерним. В данном случае это не нужно, но дописать, чтобы работало и так и так будет круто
const ControllerInnerScroll = ({ children, isActive, ...props}) => {
    const { innerActive } = useContext(ControllerContext)
    const hasInnerSlides = props[sProps.innerSlides] !== null
    return (
        <div className={`inner-scroll-slide ${isActive && hasInnerSlides ? `-active-${innerActive}` : ''}`}>
            {
                React.Children.map(children, (child) => (
                    React.cloneElement(child as React.ReactElement<any>, {
                        innerActive,
                        isActive
                    })
                ))
            }
        </div>
    )
}


export { ControllerSlides, ControllerInnerScroll }
export default Controller